import { TamediaStyles } from '@ta-interaktiv/microfrontend-template-helpers'
import styled, { ThemeProvider } from 'styled-components'
import { GlobalVariables } from 'Globals/GlobalVariables'
import DayLightChartScroll from 'components/DayLightChartScroll'
import { useState, useEffect } from 'react'
import * as d3 from 'd3'
import Header from 'components/Header'
import { GetTheme } from '../../theme/config'
import { useTranslation } from 'react-i18next'
import '../../i18n'

// https://master.dev.tdg.ch/changement-d-heure-110177234244?preview_key=8e19ceadd0361451ff612ea50f81e112
// Article en relation 520764657281
// DCH: https://www.tagesanzeiger.ch/zeitumstellung-wird-die-sommerzeit-bald-abgeschafft-512215977593?preview_key=420de65f12bccff452e63263176ca5a5

const MainComponent = ({
  tenant,
  colorMode,
  properties,
  trackEvent,
}: MicroFrontendProps) => {
  const [data, setData] = useState<MyCsvRow[]>([])
  const theme = GetTheme(colorMode, tenant)
  const { i18n, t } = useTranslation()

  useEffect(() => {
    d3.csv<MyCsvRow>(
      `${
        process.env.NODE_ENV === 'production'
          ? 'https://dev-interaktiv-mf.tagesanzeiger.ch/2024/changement-d-heure'
          : ''
      }/daylight.csv`,
      (d) => {
        return {
          sunset: d['Sunset'],
          sunrise: d['Sunrise'],
          sunsetDecimal: +d['Sunset - decimal'],
          sunriseDecimal: +d['Sunrise - decimal'],
          date: new Date(d['Date']),
        }
      }
    )
      .then((fetchData) => {
        setData(fetchData)
      })
      .catch((error) => {
        console.error('Error fetching the CSV data:', error)
      })
  }, [])

  useEffect(() => {
    i18n.changeLanguage(tenant.lang)
  }, [tenant])

  return (
    <AppContainer $colorMode={colorMode}>
      <ThemeProvider theme={theme}>
        <Header
          keywords={t('header:keywords')}
          title={t('header:title')}
          lead={t('header:lead')}
          authors={t('header:authors')}
          date={t('header:date')}
        />
        <DayLightChartScroll data={data} />
      </ThemeProvider>
    </AppContainer>
  )
}
const AppContainer = styled(TamediaStyles)`
  ${GlobalVariables}
  font-family: var(--font-sans-serif);
  font-size: 1.8rem;
  line-height: 3rem;
  margin-bottom: 90px;
`
export default MainComponent
